import mediator from "@tvg/mediator";

export const getUserCompliance = () => {
  setTimeout(() => {
    mediator.base.dispatch({
      type: "UM_ACCOUNT_COMPLIANCE"
    });
  }, 1000);
};
